module.exports = __webpack_public_path__ + "static/media/background.064f663b.svg";